export const scrollTo = ({ _el, _cont, diff = 225 }) => {
  if (_el) {
    _cont.scrollTo({
      top: _el.offsetTop - diff,
      behavior: 'smooth',
    });
  }
}
